<template>
    <button
        @click="toggleAccordion"
        :ref="id"
        :class="[
            {
                'open': accordionOpen,
            },
            'accordion-item d-block'
        ]"
    >
        <h3 class="accordion-title">
            <span v-html="title" />
            <span
                v-if="subtitle"
                class="accordion-subtitle hidden-until-md"
            >
                {{ subtitle }}
            </span>
            <icon
                icon="chevron-right"
            />
        </h3>
        <div
            class="accordion-inner mt-4"
        >
            <slot />
        </div>
    </button>
</template>

<script>
    import Icon from './icon.vue';

    export default {
        name: 'Accordion',
        components: {
            Icon,
        },
        data() {
            return {
                accordionOpen: false,
            };
        },
        props: {
            title: {
                required: true,
                type: String,
            },
            subtitle: {
                required: false,
                type: String,
            },
            id: {
                required: false,
                type: Number,
            },
        },
        methods: {
            toggleAccordion() {
                this.accordionOpen = !this.accordionOpen;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .accordion {
        &-item {
            width: 100%;
            padding: 24px;
            margin-bottom: 16px;
            cursor: pointer;
            background-color: #fff;
            border: 1px solid $shadow-green;
            border-radius: 3px;
            transition: border-color 0.2s;

            &:last-of-type {
                margin-bottom: 35px;
            }

            &:hover {
                border-color: $mineral-green;
            }

            &.open {
                border-color: $mineral-green;
            }
        }

        &-inner {
            display: none;
            font-size: 14px;

            .open & {
                display: block;
            }
        }

        &-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0;
            font-family: $font;
            font-size: 16px;
            font-weight: 700;
            line-height: 16px;
            color: $mineral-green;

            .icon {
                font-size: 18px;
                color: $mineral-green;
                transition: transform 0.3s;
                transform: rotate(90deg);

                .open & {
                    transform: rotate(90deg) scale(-1);
                }
            }
        }

        &-subtitle {
            margin: 0 16px 0 auto;
            font-size: 12px;
            color: $tapa;
        }

        &-text {
            font-size: 14px;
            line-height: 26px;
        }
    }
</style>
